import { render, staticRenderFns } from "./Page_DiscountPartnerListing.vue?vue&type=template&id=2c819f83&scoped=true&"
import script from "./Page_DiscountPartnerListing.vue?vue&type=script&lang=js&"
export * from "./Page_DiscountPartnerListing.vue?vue&type=script&lang=js&"
import style0 from "./Page_DiscountPartnerListing.vue?vue&type=style&index=0&id=2c819f83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c819f83",
  null
  
)

export default component.exports